import { useEffect } from 'react'

const SUFFIX = 'Garage Sale Mapper'

function setMetaTag(property, content) {
  if (!content) return
  // Try property-based (og:*) first, then name-based (twitter:*)
  let el = document.querySelector(`meta[property="${property}"]`) ||
           document.querySelector(`meta[name="${property}"]`)
  if (el) {
    el.setAttribute('content', content)
  }
}

export function usePageTitle(title, { description, ogImage } = {}) {
  useEffect(() => {
    document.title = title ? `${title} | ${SUFFIX}` : SUFFIX

    if (title) {
      setMetaTag('og:title', title)
      setMetaTag('twitter:title', title)
    }

    if (description) {
      setMetaTag('description', description)
      setMetaTag('og:description', description)
      setMetaTag('twitter:description', description)
    }

    setMetaTag('og:url', window.location.href)

    if (ogImage) {
      setMetaTag('og:image', ogImage)
      setMetaTag('twitter:image', ogImage)
    }

    return () => {
      document.title = SUFFIX
    }
  }, [title, description, ogImage])
}
